import React from 'react';
import Image from 'next/image';

const CompanionThumbnail = ({ tokenId, size }) => {
  const src = `${process.env.NEXT_PUBLIC_COMPANIONS_THUMBNAIL_BASEURL}${tokenId}.png`;

  return (
    <div>
      <Image
        src={src}
        alt={`Frendle #${tokenId}`}
        width={size}
        height={size}
        unoptimized
      />
      <div>
        <div className="p-1 text-center fw-bold">Frendle #{tokenId}</div>
      </div>
    </div>
  );
};

CompanionThumbnail.defaultProps = {
  size: 200,
};

export default CompanionThumbnail;
